import { __assign, __extends } from "tslib";
import * as React from 'react';
import { DirectionalHint } from '@fluentui/react/lib/Callout';
import { AppCallout, AppLabel } from '@ms/app-commanding-ui/lib/UISurfaces/controls';
import { AppBaseButton } from '@ms/app-commanding-ui/lib/UISurfaces/controls/AppBaseButton';
import { AppMessageBar, AppMessageBarType } from '@ms/app-commanding-ui/lib/UISurfaces/MessageBar';
import { Icon } from '@fluentui/react/lib/Icon';
import { getDocumentTitleCalloutStyles, } from './DocumentTitleCallout.styles';
import { KeyCodes } from '@fluentui/react/lib/Utilities';
import { LogCategory, TraceLevel, ULS } from '@ms/office-online-telemetry/lib/';
import { FocusTrapZone } from '@fluentui/react/lib/FocusTrapZone';
import { DocumentTitleCalloutInput } from '../DocumentTitleCalloutInput';
import { DocumentTitleCalloutLocation } from '../DocumentTitleCalloutLocation';
import { sendTelemetryEvent } from '@ms/office-online-otel';
import { AppThemeConsumer } from '@ms/acui-theme';
var SuggestedNameResult;
(function (SuggestedNameResult) {
    SuggestedNameResult[SuggestedNameResult["RevertedTitle"] = 0] = "RevertedTitle";
    SuggestedNameResult[SuggestedNameResult["AcceptedSuggestedTitle"] = 1] = "AcceptedSuggestedTitle";
    SuggestedNameResult[SuggestedNameResult["ModifiedSuggestedTitle"] = 2] = "ModifiedSuggestedTitle";
})(SuggestedNameResult || (SuggestedNameResult = {}));
var DocumentTitleCallout = /** @class */ (function (_super) {
    __extends(DocumentTitleCallout, _super);
    function DocumentTitleCallout(props) {
        var _this = _super.call(this, props) || this;
        _this.isDocumentTitleAppInputDirty = false;
        // Used to prevent closing of the callout by selecting DTT input text (mouse down) and releasing (mouse up)
        // outside of the callout (this mouse up triggers callout close)
        _this.mouseDownInsideCalloutActive = false;
        _this.isDismissed = false;
        _this.setMouseDownInsideCalloutOn = function () {
            _this.mouseDownInsideCalloutActive = true;
        };
        _this.setMouseDownInsideCalloutOff = function () {
            _this.mouseDownInsideCalloutActive = false;
        };
        _this.setStateDocumentTitle = function (newValue) {
            var documentTitle = newValue || '';
            _this.setState({
                documentTitle: documentTitle,
            }, function () {
                _this.isDocumentTitleAppInputDirty = true;
            });
        };
        _this.onVersionHistoryDivClicked = function () {
            if (_this.props.versionHistoryButtonProps) {
                _this.props.versionHistoryButtonProps.onExecute();
                _this.props.closeCallout();
            }
        };
        _this.onVersionHistoryLinkClick = function (ev) {
            ev.preventDefault();
        };
        _this.onCalloutDismiss = function (ev) {
            // track whether onCalloutDismiss will close the callout,
            // otherwise CommitDocumentTitle gets called recursively a second time on unmount and calls
            // props.closeCallout() twice
            var shouldCloseCallout = !_this.mouseDownInsideCalloutActive;
            _this.isDismissed = shouldCloseCallout;
            if (ev && 'keyCode' in ev && ev.keyCode === KeyCodes.escape) {
                ev.preventDefault();
                ev.stopPropagation();
                _this.setState({
                    documentTitle: _this.props.documentTitle || '',
                }, _this.props.closeCallout);
            }
            else {
                _this.commitDocumentTitle(shouldCloseCallout);
                if (_this.mouseDownInsideCalloutActive) {
                    // If mouse up wasn't caught by input (released outside of callout), trigger it now
                    // to prevent forever blocking callout closing
                    _this.setMouseDownInsideCalloutOff();
                }
            }
        };
        _this.onCalloutKeyUp = function (ev) {
            if (ev.which === KeyCodes.up && (ev.altKey || ev.metaKey)) {
                ev.preventDefault();
                ev.stopPropagation();
                _this.commitDocumentTitle();
            }
        };
        _this.isRenameSupported = function () { return !_this.props.hideDocumentTitleInput; };
        _this.commitDocumentTitle = function (shouldCloseCallout) {
            if (shouldCloseCallout === void 0) { shouldCloseCallout = true; }
            var newDocumentTitle = _this.state.documentTitle;
            var documentTitle = _this.props.documentTitle;
            if (_this.props.suggestedDocumentTitle && _this.isDocumentTitleAppInputDirty && newDocumentTitle === documentTitle) {
                _this.isDocumentTitleAppInputDirty = false;
                sendTelemetryEvent({
                    name: 'Office.FileIO.Online.DTT.SuggestedNameStatus',
                    dataFields: [{ name: 'SuggestionStatus', int64: SuggestedNameResult.RevertedTitle }],
                });
            }
            if (_this.isRenameSupported() &&
                _this.props.onRename &&
                newDocumentTitle.length > 0 &&
                newDocumentTitle !== documentTitle &&
                _this.isDocumentTitleAppInputDirty) {
                _this.isDocumentTitleAppInputDirty = false;
                if (_this.props.suggestedDocumentTitle) {
                    if (newDocumentTitle === _this.props.suggestedDocumentTitle) {
                        sendTelemetryEvent({
                            name: 'Office.FileIO.Online.DTT.SuggestedNameStatus',
                            dataFields: [{ name: 'SuggestionStatus', int64: SuggestedNameResult.AcceptedSuggestedTitle }],
                        });
                    }
                    else {
                        sendTelemetryEvent({
                            name: 'Office.FileIO.Online.DTT.SuggestedNameStatus',
                            dataFields: [{ name: 'SuggestionStatus', int64: SuggestedNameResult.ModifiedSuggestedTitle }],
                        });
                    }
                }
                _this.props.onRename(newDocumentTitle);
            }
            if (shouldCloseCallout) {
                if (_this.props.closeCallout) {
                    _this.props.closeCallout();
                }
                else {
                    ULS.sendTraceTag(0x2364f2a1 /* tag_9zpk7 */, LogCategory.msoulscat_Wac_Ribbon, TraceLevel.Warning, "commitDocumentTitle: typeof props.closeCallout: " + typeof _this.props.closeCallout);
                }
            }
        };
        _this.onInputKeyDown = function (ev) {
            if (ev.which === KeyCodes.enter) {
                ev.preventDefault();
                ev.stopPropagation();
                _this.commitDocumentTitle();
            }
        };
        _this.state = {
            documentTitle: props.suggestedDocumentTitle || props.documentTitle || '',
        };
        if (props.suggestedDocumentTitle) {
            _this.isDocumentTitleAppInputDirty = true;
        }
        return _this;
    }
    DocumentTitleCallout.prototype.componentDidUpdate = function (prevProps) {
        if (this.props.documentTitle !== prevProps.documentTitle && prevProps.documentTitle === this.state.documentTitle) {
            this.setState({ documentTitle: this.props.documentTitle || '' });
        }
    };
    DocumentTitleCallout.prototype.render = function () {
        var _this = this;
        var _a = this.props, colors = _a.colors, breadcrumbBrandName = _a.breadcrumbBrandName, saveStatus = _a.saveStatus, versionHistoryButtonProps = _a.versionHistoryButtonProps;
        var renderTitle = this.isRenameSupported();
        var renderLocation = Boolean(breadcrumbBrandName);
        var renderSaveStatus = Boolean(saveStatus) && Boolean(this.props.strings.saveStatusLabel);
        var renderVersionHistory = Boolean(versionHistoryButtonProps);
        return (React.createElement(AppThemeConsumer, null, function () {
            var documentTitleCalloutStyles = getDocumentTitleCalloutStyles(colors);
            return (React.createElement(AppCallout, { gapSpace: -4, target: _this.props.menuButtonElement, isBeakVisible: true, beakWidth: 18, onDismiss: _this.onCalloutDismiss, onKeyUp: _this.onCalloutKeyUp, directionalHint: DirectionalHint.bottomCenter, styles: documentTitleCalloutStyles.calloutContent, setInitialFocus: !_this.isRenameSupported(), calloutMaxWidth: 384 },
                React.createElement(FocusTrapZone, { isClickableOutsideFocusTrap: true, forceFocusInsideTrap: false, disableFirstFocus: !_this.isRenameSupported() },
                    _this.renderMessageBar(documentTitleCalloutStyles.classNames),
                    renderTitle && _this.renderTitleSection(documentTitleCalloutStyles.classNames),
                    renderLocation && _this.renderLocationSection(renderTitle, documentTitleCalloutStyles.classNames),
                    renderSaveStatus &&
                        _this.renderSaveStatusSection(renderTitle || renderLocation, documentTitleCalloutStyles),
                    renderVersionHistory &&
                        _this.renderVersionHistorySection(renderTitle || renderLocation || renderSaveStatus, documentTitleCalloutStyles.classNames))));
        }));
    };
    DocumentTitleCallout.prototype.renderMessageBar = function (classNames) {
        if (!this.props.message) {
            return React.createElement(React.Fragment, null);
        }
        return (React.createElement("div", { className: classNames.messageSection },
            React.createElement(AppMessageBar, { message: this.props.message, messageBarType: AppMessageBarType.info, type: "AppMessageBarProps" })));
    };
    DocumentTitleCallout.prototype.componentWillUnmount = function () {
        // This explicit call is needed since OnCalloutDismiss isn't called when clicking on the DTT button a second time.
        if (!this.isDismissed) {
            this.commitDocumentTitle();
        }
    };
    DocumentTitleCallout.prototype.isExtensionValid = function (extension) {
        if (extension && extension.length > 1 && extension[0] === '.') {
            return true;
        }
        return false;
    };
    DocumentTitleCallout.prototype.onRenderCalloutSuffix = function () {
        var _this = this;
        return function () {
            var classNames = getDocumentTitleCalloutStyles(_this.props.colors).classNames;
            return React.createElement("span", { className: classNames.documentExtension }, _this.props.documentExtension);
        };
    };
    DocumentTitleCallout.prototype.renderTitleSection = function (classNames) {
        return (React.createElement("div", { className: classNames.documentTitleSection, onMouseDown: this.setMouseDownInsideCalloutOn, onMouseUp: this.setMouseDownInsideCalloutOff },
            React.createElement(DocumentTitleCalloutInput, { value: this.state.documentTitle, onChange: this.setStateDocumentTitle, onKeyDown: this.onInputKeyDown, readOnly: this.props.readOnlyDocumentTitleInput, label: this.props.strings.documentName, onRenderSuffix: this.isExtensionValid(this.props.documentExtension) ? this.onRenderCalloutSuffix() : undefined })));
    };
    DocumentTitleCallout.prototype.renderSaveStatusSection = function (sectionAbove, styles) {
        if (this.props.strings.saveStatusLabel) {
            return (React.createElement(React.Fragment, null,
                sectionAbove && React.createElement("div", { className: styles.classNames.sectionDivider }),
                React.createElement("div", { className: styles.classNames.saveStatusSection },
                    React.createElement(AppLabel, { type: 'AppLabelProps', id: "saveStatusLabel", styles: styles.labelStyles, forId: "saveStatusValue", label: this.props.strings.saveStatusLabel }),
                    React.createElement("div", { className: styles.classNames.saveStatusValue, id: "saveStatusValue" }, this.props.saveStatus))));
        }
        return React.createElement(React.Fragment, null);
    };
    DocumentTitleCallout.prototype.renderLocationSection = function (sectionAbove, classNames) {
        return (React.createElement(React.Fragment, null,
            sectionAbove && React.createElement("div", { className: classNames.sectionDivider }),
            React.createElement(DocumentTitleCalloutLocation, { colors: this.props.colors, breadcrumbBrandName: this.props.breadcrumbBrandName, breadcrumbBrandUrl: this.props.breadcrumbBrandUrl, breadcrumbFolderName: this.props.breadcrumbFolderName, breadcrumbFolderUrl: this.props.breadcrumbFolderUrl, strings: this.props.strings, icons: this.props.icons, isMoveEnabled: this.props.isMoveEnabled, cleanupAndDismissCalloutCallback: this.commitDocumentTitle, onMove: this.props.onMove })));
    };
    DocumentTitleCallout.prototype.renderVersionHistorySection = function (sectionAbove, classNames) {
        if (!this.props.versionHistoryButtonProps) {
            return React.createElement(React.Fragment, null);
        }
        var innerContent = (React.createElement(React.Fragment, null,
            React.createElement(Icon, __assign({ className: classNames.versionHistoryIcon }, this.props.icons.versionHistory)),
            this.props.versionHistoryButtonProps.label));
        var commonInnerContentProps = {
            'data-unique-id': 'VersionHistoryLink',
            onClick: this.onVersionHistoryLinkClick,
        };
        return (React.createElement(React.Fragment, null,
            sectionAbove && React.createElement("div", { className: classNames.sectionDivider }),
            React.createElement("div", { className: classNames.versionHistorySection },
                React.createElement("div", { className: classNames.versionHistory, onClick: this.onVersionHistoryDivClicked }, this.props.versionHistoryButtonProps.isExternalLink ? (React.createElement("a", __assign({ className: classNames.versionHistoryTitle }, commonInnerContentProps, { href: "#" }), innerContent)) : (React.createElement(AppBaseButton, __assign({ className: classNames.versionHistoryTitleAppButton }, commonInnerContentProps), innerContent))))));
    };
    return DocumentTitleCallout;
}(React.PureComponent));
export { DocumentTitleCallout };
//# sourceMappingURL=DocumentTitleCallout.js.map